'use client';

import clsx from 'clsx';
import { useLayoutEffect, useState } from 'react';

export default function ArrowBetweenElements({
  className,
  sourceSelectors,
  targetSelectors,
}) {
  const [sourceRect, setSourceRect] = useState(null);
  const [targetRect, setTargetRect] = useState(null);

  useLayoutEffect(() => {
    if (sourceRect || targetRect) {
      return () => {
        // Empty cleanup.
      };
    }

    setTimeout(() => {
      const sourceElement = document.querySelector(sourceSelectors);

      if (!sourceElement) {
        console.log(
          `Source element not found for selector "${sourceSelectors}"`
        );
        return;
      }

      const targetElement = document.querySelector(targetSelectors);

      if (!targetElement) {
        console.log(
          `Target element not found for selector "${targetSelectors}"`
        );
        return;
      }

      setSourceRect(sourceElement.getClientRects()[0]);
      setTargetRect(targetElement.getClientRects()[0]);
    }, 200);

    return () => {
      // Empty cleanup.
    };
  }, [sourceSelectors, targetSelectors]);

  if (!sourceRect || !targetRect) {
    return null;
  }

  return (
    <div
      className={clsx(className, [
        'pointer-events-none absolute left-0 top-0 -z-10 h-full w-full',
      ])}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        className="pointer-events-none"
        viewBox={`0 0 ${document.body.clientWidth} ${document.body.clientHeight}`}
        width={document.body.clientWidth}
        height={document.body.clientHeight}
      >
        <defs>
          <marker
            id="arrow"
            markerWidth="15"
            markerHeight="15"
            refX="5"
            refY="3"
            orient="auto"
            markerUnits="strokeWidth"
            viewBox="0 0 15 15"
          >
            <path d="M0,0 L0,6 L9,3 z" fill="#eee" />
          </marker>
        </defs>

        <line
          x1={sourceRect.x + sourceRect.width}
          y1={sourceRect.y + sourceRect.height / 2 + window.scrollY}
          x2={targetRect.x}
          y2={targetRect.y + targetRect.height / 2 + window.scrollY}
          z={-1}
          stroke="#eee"
          strokeWidth="2"
          markerEnd="url(#arrow)"
        />
      </svg>
    </div>
  );
}
